"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnalyticsContextProvider = void 0;
exports.startTelemetry = startTelemetry;
exports.useAnalytics = void 0;
var _react = _interopRequireWildcard(require("react"));
var _analyticsNext = require("@segment/analytics-next");
var _browser = require("@fullstory/browser");
var _PageContext = require("./PageContext");
var Sentry = _interopRequireWildcard(require("@sentry/react"));
var _document = require("../utils/document");
var _AuthContext = require("./AuthContext");
var _useOrgFeatureFlag = _interopRequireDefault(require("../hooks/useOrgFeatureFlag"));
var _envManager = require("../utils/envManager");
var _errors = require("../utils/errors");
var _constants = require("../constants");
var _privacy = require("@common/sentry/privacy");
var _environments = require("../utils/environments");
var _sentryReporter = require("../utils/sentry-reporter");
var _sentryTunnel = require("../utils/sentry-tunnel");
var _analyticsOrgEventProperties = require("../utils/analytics-org-event-properties");
var _useScrollBoxReporting = require("../hooks/use-scroll-box-reporting");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var SENTRY_DSN = (0, _envManager.getEnv)("SENTRY_DSN");
var EXPECTED_CLIENT_ERROR_STATUSES = new Set([400, 401, 403, 404, 409, 422]);
var CUSTOMER_BACKEND_HOSTS = [(0, _envManager.getEnv)("API_BASE_URL"), (0, _envManager.getEnv)("WEBAPP_API_BASE_URL")].concat(_toConsumableArray(_environments.VERA_ENVIRONMENTS.flatMap(function (env) {
  return [env.appUrl, env.apiUrl];
}))).filter(function (value) {
  return Boolean(value);
});
function detectEnvironment() {
  var loginMethod = localStorage.getItem(_constants.DIOPTRA_LOGIN_METHOD);
  var platform = loginMethod === "icertis" ? "icertis" : "dioptra";
  var region = "us";
  var tier = "production";
  if (platform === "icertis") {
    var appUrl = (0, _envManager.getEnv)("WEBAPP_API_BASE_URL");
    if (appUrl !== null && appUrl !== void 0 && appUrl.includes("-eu.")) region = "eu";
    if (appUrl !== null && appUrl !== void 0 && appUrl.includes("cust-staging-")) tier = "staging";
  }
  return {
    platform: platform,
    region: region,
    tier: tier
  };
}
var SENTRY_INIT_OPTIONS = {
  dsn: SENTRY_DSN,
  tunnel: (0, _sentryTunnel.webappSentryTunnelUrl)(SENTRY_DSN, (0, _envManager.getEnv)("WEBAPP_API_BASE_URL")),
  environment: (0, _envManager.getEnv)("SENTRY_ENVIRONMENT") || "production",
  release: (0, _envManager.getPluginVersion)(),
  initialScope: {
    tags: {
      surface: "word-addin"
    }
  },
  sendDefaultPii: false,
  enableLogs: true,
  integrations: [Sentry.replayIntegration(_objectSpread(_objectSpread({}, _privacy.REPLAY_PRIVACY_DEFAULTS), {}, {
    networkDetailAllowUrls: [/^https:\/\/app\.dioptra\.ai\/.*/, /^https:\/\/api\.dioptra\.ai\/.*/, /^https:\/\/wsgr\.document-review\.dioptra\.ai\/.*/].concat(_toConsumableArray(CUSTOMER_BACKEND_HOSTS)),
    networkCaptureBodies: false
  })), Sentry.browserTracingIntegration(), Sentry.browserProfilingIntegration(), Sentry.extraErrorDataIntegration(), Sentry.consoleLoggingIntegration({
    levels: ["error", "warn", "log", "info", "debug"]
  })],
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
  tracesSampleRate: 1.0,
  tracePropagationTargets: [
  // localhost so addin->FE calls (WEBAPP_API_BASE_URL=https://localhost:3001)
  // carry sentry-trace/baggage in local dev; no-op in prod where the addin
  // hits app.dioptra.ai. Lets a FE-side error share a trace with the addin session.
  "localhost", "app.dioptra.ai", "api.dioptra.ai", "wsgr.document-review.dioptra.ai"].concat(_toConsumableArray(CUSTOMER_BACKEND_HOSTS)),
  profilesSampleRate: 1.0,
  beforeSend: function beforeSend(event) {
    // @ts-expect-error — scrubEvent operates on the Sentry ErrorEvent shape intentionally
    (0, _privacy.scrubEvent)(event);
    return event;
  }
};
var ERROR_CATEGORY_BY_MESSAGE_WORDS = [[["parse", "JSON"], "parsing_error"], [["stream", "chat"], "chat_stream_error"], [["conversation", "create"], "conversation_error"], [["file", "upload", "download"], "file_operation_error"], [["comment", "redline", "document"], "document_processing_error"], [["bookmark", "OOXML"], "document_manipulation_error"], [["network", "fetch", "API"], "network_error"]];
var UNKNOWN_ERROR_CATEGORY = "unknown";
function errorCategoryOf(errorMessage) {
  var matched = ERROR_CATEGORY_BY_MESSAGE_WORDS.find(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      words = _ref2[0];
    return words.some(function (word) {
      return errorMessage.includes(word);
    });
  });
  return matched ? matched[1] : UNKNOWN_ERROR_CATEGORY;
}
var AnalyticsContext = /*#__PURE__*/(0, _react.createContext)({
  analytics: null,
  sendMessage: function sendMessage() {},
  sendError: function sendError() {}
});
var analytics = new _analyticsNext.AnalyticsBrowser();
function startTelemetry() {
  Sentry.init(SENTRY_INIT_OPTIONS);
  analytics.load({
    writeKey: (0, _envManager.getEnv)("SEGMENT_WRITE_KEY"),
    plugins: [(0, _analyticsOrgEventProperties.orgEventPropertiesPlugin)()]
  });
}
var AnalyticsContextProvider = exports.AnalyticsContextProvider = function AnalyticsContextProvider(_ref3) {
  var _orgHelper$getOrgIds;
  var children = _ref3.children;
  var _usePage = (0, _PageContext.usePage)(),
    currentPage = _usePage.currentPage;
  var _useAuthInfo = (0, _AuthContext.useAuthInfo)(),
    user = _useAuthInfo.user,
    orgHelper = _useAuthInfo.orgHelper;
  var orgID = orgHelper === null || orgHelper === void 0 || (_orgHelper$getOrgIds = orgHelper.getOrgIds()) === null || _orgHelper$getOrgIds === void 0 ? void 0 : _orgHelper$getOrgIds[0];
  var org = orgID ? orgHelper === null || orgHelper === void 0 ? void 0 : orgHelper.getOrg(orgID) : null;
  var isSentryReplayDisabled = (0, _useOrgFeatureFlag.default)("is_sentry_replay_disabled");
  (0, _useScrollBoxReporting.useScrollBoxReporting)(currentPage);
  (0, _react.useEffect)(function () {
    if (isSentryReplayDisabled) {
      var _Sentry$getReplay;
      void ((_Sentry$getReplay = Sentry.getReplay()) === null || _Sentry$getReplay === void 0 ? void 0 : _Sentry$getReplay.stop());
    }
  }, [isSentryReplayDisabled]);
  (0, _react.useEffect)(function () {
    var _user$userId;
    (0, _sentryReporter.setReporterContext)({
      page: currentPage || null,
      userId: (_user$userId = user === null || user === void 0 ? void 0 : user.userId) !== null && _user$userId !== void 0 ? _user$userId : null,
      orgId: orgID !== null && orgID !== void 0 ? orgID : null
    });
  }, [currentPage, user === null || user === void 0 ? void 0 : user.userId, orgID]);
  var sendMessage = (0, _react.useCallback)(function (message) {
    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'info';
    (0, _sentryReporter.reportMessage)(message, {
      level: level
    });
  }, []);
  var sendError = (0, _react.useCallback)(function (error, context) {
    var _storedContext$page, _callerContext$conver, _context$level;
    var diagnosedError = (0, _document.diagnoseDocumentError)((0, _errors.toError)(error));
    var errorCategory = errorCategoryOf(diagnosedError.message);
    var storedContext = (0, _sentryReporter.reporterContextSnapshot)();
    var callerContext = context !== null && context !== void 0 ? context : {};
    var reportedContext = _objectSpread(_objectSpread(_objectSpread({}, storedContext), callerContext), {}, {
      page: (_storedContext$page = storedContext.page) !== null && _storedContext$page !== void 0 ? _storedContext$page : callerContext.page,
      conversationId: (_callerContext$conver = callerContext.conversationId) !== null && _callerContext$conver !== void 0 ? _callerContext$conver : storedContext.conversationId,
      component: callerContext.component,
      action: callerContext.action,
      errorCategory: errorCategory,
      errorType: diagnosedError.constructor.name
    });
    var isExpectedClientError = diagnosedError instanceof _errors.UserFacingError && typeof diagnosedError.status === "number" && EXPECTED_CLIENT_ERROR_STATUSES.has(diagnosedError.status);
    (0, _sentryReporter.reportError)(diagnosedError, {
      level: (_context$level = context === null || context === void 0 ? void 0 : context.level) !== null && _context$level !== void 0 ? _context$level : isExpectedClientError ? "warning" : "error",
      fingerprint: context === null || context === void 0 ? void 0 : context.fingerprint,
      extra: reportedContext
    });
    analytics.track('error_occurred', {
      error_category: errorCategory,
      error_message: diagnosedError.message.substring(0, 200),
      conversation_id: reportedContext.conversationId,
      page: reportedContext.page,
      component: reportedContext.component,
      action: reportedContext.action,
      user_id: reportedContext.userId,
      org_id: reportedContext.orgId
    });
  }, []);
  (0, _react.useEffect)(function () {
    if ((0, _envManager.getEnv)("FULLSTORY_ORG")) {
      (0, _browser.init)({
        orgId: (0, _envManager.getEnv)("FULLSTORY_ORG")
      }, function (_ref4) {
        var sessionUrl = _ref4.sessionUrl;
        return console.log("Started session: ".concat(sessionUrl));
      });
      if (user !== null && user !== void 0 && user.email) {
        (0, _browser.FullStory)("setIdentity", {
          uid: user.userId,
          properties: {
            email: user.email
          }
        });
      }
    }
    if (user && analytics) {
      analytics.identify(user.userId, {
        email: user.email,
        org: org === null || org === void 0 ? void 0 : org.orgName,
        orgId: orgID
      }, {
        anonymousId: user.userId
      });
    }
    var email = (0, _privacy.maskEmailsInString)(user.email);
    Sentry.setUser({
      id: user.userId,
      email: email
    });
    // Org as tags (matches the web FE's setSentryUser) so the two projects
    // pivot consistently by organization when correlating a user.
    Sentry.setTag("organization.id", orgID);
    if (org !== null && org !== void 0 && org.orgName) Sentry.setTag("organization.name", org.orgName);
    var _detectEnvironment = detectEnvironment(),
      platform = _detectEnvironment.platform,
      region = _detectEnvironment.region,
      tier = _detectEnvironment.tier;
    Sentry.setTag("login_platform", platform);
    Sentry.setTag("region", region);
    Sentry.setTag("tier", tier);
  }, [user.userId, user.email, orgID, org === null || org === void 0 ? void 0 : org.orgName]);
  (0, _react.useEffect)(function () {
    if (!analytics) return;
    if (currentPage) analytics.page(currentPage);
    var clickHandler = function clickHandler(e) {
      var target = e.target;
      switch (target.tagName.toUpperCase()) {
        case "A":
          analytics.track("click", {
            category: target.tagName.toLowerCase(),
            label: target.textContent,
            href: target.href,
            page: currentPage
          });
          break;
        case "BUTTON":
          analytics.track("click", {
            category: target.tagName.toLowerCase(),
            label: target.textContent,
            page: currentPage
          });
          break;
        case "INPUT":
        case "TEXTAREA":
        case "SELECT":
          analytics.track("click", {
            category: "".concat(target.tagName.toLowerCase(), "-").concat(target.type),
            label: target.getAttribute("placeholder") || target.value,
            page: currentPage
          });
          break;
        case "SVG":
        case "PATH":
        case "IMG":
          analytics.track("click", {
            category: target.tagName.toLowerCase(),
            label: target.getAttribute("aria-label") || target.getAttribute("class"),
            page: currentPage
          });
          break;
        default:
          if (target.classList.contains("underline") || target.onclick || target.closest("button") || target.closest("a")) {
            analytics.track("click", {
              category: target.tagName.toLowerCase(),
              label: target.textContent,
              page: currentPage
            });
          }
          break;
      }
    };
    document.addEventListener("click", clickHandler);
    return function () {
      document.removeEventListener("click", clickHandler);
    };
  }, [currentPage]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(AnalyticsContext.Provider, {
    value: {
      analytics: analytics,
      sendMessage: sendMessage,
      sendError: sendError
    },
    "data-sentry-element": "AnalyticsContext.Provider",
    "data-sentry-component": "AnalyticsContextProvider",
    "data-sentry-source-file": "AnalyticsContext.tsx",
    children: children
  });
};
var useAnalytics = exports.useAnalytics = function useAnalytics() {
  var _useContext = (0, _react.useContext)(AnalyticsContext),
    analytics = _useContext.analytics,
    sendMessage = _useContext.sendMessage,
    sendError = _useContext.sendError;
  return {
    analytics: analytics,
    sendMessage: sendMessage,
    sendError: sendError
  };
};